import React, { Component } from 'react';
import MenuBar from '../menu-bar/menu-bar'
import xesProjectLoadHoc from '../../lib/xes/xes-project-load'
import xesHoc from '../../lib/xes/xes-hoc'
import { Platform } from '../../lib/xes/xes'
import xesBridge from 'xes-code-base/lib/libs/xes'
import BaizeLottie from '../baize-lottie/baize-lottie.jsx'
class Gui extends Component {
  componentDidMount() {
    if (Platform.isIPad()) {
      // window.alert('硬件课程不支持使用移动端，请使用电脑客户端练习')
    }
    // xesBridge.onloadWindowFunction()
  }
  render() {
    const {baizeState} = this.props.state.scratchGui
    console.log('baize--', this.props);
    return (
      <div>
        {Platform.isHomeworkCorrectApp()? null:
        <MenuBar></MenuBar>}
        {/* <div id='baize-lottie'></div> */}
        {baizeState.baizeLottie? <BaizeLottie id='baize-lottie' rightcount={baizeState.baizeRightCount}/>: null}
      </div>
    );
  }
}

export default xesProjectLoadHoc(xesHoc(Gui));